// locales/en.json
var en_default = {
  $meta: {
    locale: "en",
    direction: "ltr"
  },
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.confirm": "Are you sure?",
  "common.create": "Create",
  "common.edit": "Edit",
  "common.clear": "Clear",
  "common.title": "Title",
  "common.view": "View",
  "common.add": "Add",
  "common.remove": "Remove",
  "common.search": "Search...",
  "common.filter": "Filter",
  "common.actions": "Actions",
  "common.yes": "Yes",
  "common.no": "No",
  "common.selected": "selected",
  "common.ok": "OK",
  "common.done": "Done",
  "common.apply": "Apply",
  "common.reset": "Reset",
  "common.refresh": "Refresh",
  "common.export": "Export",
  "common.import": "Import",
  "common.copy": "Copy",
  "common.settings": "Settings",
  "nav.previous": "Previous",
  "nav.next": "Next",
  "nav.back": "Back",
  "nav.home": "Home",
  "form.submit": "Submit",
  "form.saving": "Saving...",
  "form.required": "This field is required",
  "form.invalidEmail": "Enter a valid email address",
  "form.selectPlaceholder": "Select {{label}}...",
  "form.searchPlaceholder": "Search {{entity}}...",
  "table.empty.title": "No items found",
  "table.empty.description": "No items to display.",
  "table.search.placeholder": "Search...",
  "table.pagination.showing": "Showing {{start}} to {{end}} of {{total}} results",
  "table.pagination.page": "Page {{page}} of {{totalPages}}",
  "table.bulk.selected": "{{count}} selected",
  "table.loading": "Loading...",
  "status.loading": "Loading...",
  "status.scheduled": "Scheduled",
  "status.inProgress": "In Progress",
  "status.completed": "Completed",
  "status.cancelled": "Cancelled",
  "status.pending": "Pending",
  "status.active": "Active",
  "status.inactive": "Inactive",
  "status.draft": "Draft",
  "status.archived": "Archived",
  "error.generic": "Something went wrong",
  "error.traitMountFailed": "{{trait}} failed to start",
  "error.retry": "Try again",
  "error.notFound": "Not found",
  "error.loadFailed": "Failed to load: {{message}}",
  "error.configMissing": "Configuration not found for: {{id}}",
  "common.loading": "Loading...",
  "common.showMore": "Show More",
  "common.showLess": "Show Less",
  "common.noResults": "No results found",
  "common.saveChanges": "Save Changes",
  "common.retry": "Retry",
  "common.open": "Open",
  "common.back": "Back",
  "empty.noItems": "No items",
  "empty.noData": "No data available",
  "empty.noItemsYet": "No items yet",
  "empty.noItemsAdded": "No items added yet",
  "empty.noOptionsFound": "No options found",
  "list.addItemPlaceholder": "Add new item...",
  "error.occurred": "An error occurred",
  "error.failedToLoad": "Failed to load data",
  "wizard.back": "Back",
  "wizard.next": "Next",
  "wizard.complete": "Complete",
  "wizard.stepOf": "Step {{current}} of {{total}}",
  "pagination.previous": "Previous",
  "pagination.next": "Next",
  "pagination.total": "Total:",
  "pagination.show": "Show:",
  "pagination.goTo": "Go to:",
  "pagination.go": "Go",
  "auth.signIn": "Sign in",
  "auth.signOut": "Sign out",
  "auth.welcomeTo": "Welcome to {{appName}}",
  "auth.brandingSubtitle": "Sign in to access your dashboard and manage your account.",
  "dialog.confirm": "Confirm",
  "dialog.cancel": "Cancel",
  "dialog.loading": "Loading...",
  "dialog.delete.title": "Delete {{item}}?",
  "dialog.delete.message": "This action cannot be undone.",
  "trait.availableActions": "Available Actions",
  "trait.transitions": "Transitions",
  "trait.availableNow": "Available now",
  "book.startReading": "Start Reading",
  "book.tableOfContents": "Table of Contents",
  "book.partNumber": "Part {{number}}",
  "book.print": "Print",
  "book.previousPage": "Previous page",
  "book.nextPage": "Next page",
  "quiz.showAnswer": "Show answer",
  "quiz.hideAnswer": "Hide answer",
  "aria.closeModal": "Close modal",
  "aria.closeToast": "Dismiss toast",
  "aria.closeAlert": "Dismiss alert",
  "aria.removeFilter": "Remove filter",
  "aria.closeDrawer": "Close drawer",
  "aria.closePanel": "Close panel",
  "aria.dockPanel": "Side panel",
  "aria.previousImage": "Previous image",
  "aria.nextImage": "Next image",
  "aria.dismiss": "Dismiss",
  "aria.previousSlide": "Previous slide",
  "aria.nextSlide": "Next slide",
  "aria.previousDays": "Previous days",
  "aria.nextDays": "Next days",
  "aria.decrease": "Decrease",
  "aria.increase": "Increase",
  "aria.breadcrumb": "Breadcrumb",
  "aria.tableOfContents": "Table of contents",
  "aria.docsSidebar": "Documentation sidebar",
  "aria.selectAllRows": "Select all rows",
  "aria.selectAll": "Select all",
  "aria.upvote": "Upvote",
  "aria.downvote": "Downvote",
  "aria.qrScanner": "QR scanner",
  "aria.openMenu": "Open menu",
  "aria.closeMenu": "Close menu",
  "aria.openSidebar": "Open sidebar",
  "aria.openRow": "Open item {{position}}",
  "sidebar.expand": "Expand sidebar",
  "sidebar.collapse": "Collapse sidebar",
  "sidebar.close": "Close sidebar",
  "loading.items": "Loading items...",
  "card.imageAlt": "Image",
  "canvas.emptyMessage": "No content",
  "canvas.errorTitle": "Canvas error",
  "book.noData": "No data",
  "common.notifications": "Notifications",
  "common.remaining": "{{count}} remaining",
  "error.somethingWentWrong": "Something went wrong",
  "error.loadingItems": "Loading items...",
  "error.noItemsFound": "No items found",
  "debug.noEntityData": "No entity data",
  "debug.noEntities": "No entities",
  "debug.noTicks": "No ticks registered",
  "debug.noActiveTraits": "No active traits",
  "debug.noGuardEvaluations": "No guard evaluations",
  "debug.noBridgeData": "No bridge data",
  "debug.status": "Status",
  "debug.eventsForwarded": "Events Forwarded (Client \u2192 Server)",
  "debug.eventsReceived": "Events Received (Server \u2192 Client)",
  "debug.lastHeartbeat": "Last Heartbeat",
  "debug.noEventsYet": "No events yet",
  "debug.noTransitionsRecorded": "No transitions recorded",
  "debug.noVerificationChecks": "No verification checks yet",
  "display.chartError": "Chart error",
  "display.codeViewerError": "Code viewer error",
  "display.noCode": "No code",
  "display.documentError": "Document error",
  "display.noDocument": "No document",
  "display.graphError": "Graph error",
  "display.noGraphData": "No graph data",
  "display.galleryError": "Gallery error",
  "display.noMedia": "No media",
  "display.meterError": "Meter error",
  "display.signaturePadError": "Signature pad error",
  "display.timelineError": "Timeline error",
  "display.noEvents": "No events",
  "display.details": "Details",
  "display.itemNotFound": "The requested item could not be found.",
  "display.noTimelineEvents": "No timeline events to display.",
  "template.features": "Features",
  "template.howItWorks": "How It Works",
  "template.showcase": "Showcase",
  "template.faq": "Frequently Asked Questions",
  "template.ourTeam": "Our Team",
  "template.caseStudies": "Case Studies",
  "versionDiff.compare": "Compare",
  "versionDiff.changes": "Changes",
  "versionDiff.to": "to",
  "versionDiff.beforeRevision": "Before revision",
  "versionDiff.afterRevision": "After revision",
  "versionDiff.switchToInline": "Switch to inline view",
  "versionDiff.switchToSideBySide": "Switch to side-by-side view",
  "versionDiff.revert": "Revert",
  "versionDiff.byAuthor": " by {{author}}",
  "versionDiff.unchangedLines": "{{count}} unchanged lines",
  "versionDiff.noChanges": "No changes in this version.",
  "violationAlert.actionType.measure": "Corrective Measure",
  "violationAlert.actionType.admin": "Administrative Action",
  "violationAlert.actionType.penalty": "Penalty Proceedings",
  "violationAlert.fallbackMessage": "Violation",
  "violationAlert.adminLabel": "Admin:",
  "violationAlert.penaltyLabel": "Penalty:",
  "violationAlert.goToField": "Go to field",
  "branchingLogic.title": "Branching logic",
  "branchingLogic.if": "If",
  "branchingLogic.goTo": "go to",
  "branchingLogic.rules": "Rules",
  "branchingLogic.logicGraph": "Logic graph",
  "branchingLogic.addRule": "Add rule",
  "branchingLogic.deleteRule": "Delete rule",
  "branchingLogic.endOfSurvey": "End of survey",
  "branchingLogic.brokenReference": "Broken reference",
  "branchingLogic.selectQuestion": "Select question",
  "branchingLogic.selectTarget": "Select target",
  "branchingLogic.selectValue": "Select value",
  "branchingLogic.addValue": "Add value",
  "branchingLogic.value": "Value",
  "branchingLogic.typeValuePressEnter": "Type value, press Enter",
  "branchingLogic.operatorEquals": "equals",
  "branchingLogic.operatorNotEquals": "does not equal",
  "branchingLogic.operatorContains": "contains",
  "branchingLogic.operatorIn": "is one of",
  "branchingLogic.graphAriaLabel": "Branching logic graph",
  "branchingLogic.ruleCountOne": "{{count}} rule",
  "branchingLogic.ruleCountOther": "{{count}} rules",
  "branchingLogic.brokenCount": "{{count}} broken",
  "branchingLogic.emptyNoQuestions": "Add questions before building branching rules.",
  "branchingLogic.emptyNoRules": "No rules yet. Add a rule to define branching logic.",
  "filterGroup.filters": "Filters",
  "filterGroup.all": "All",
  "filterGroup.clear": "Clear",
  "filterGroup.clearAll": "Clear all",
  "filterGroup.from": "From",
  "filterGroup.to": "To",
  "filterGroup.allOf": "All {{label}}",
  "filterGroup.activeCount": "{{count}} active",
  "debug.guardEvaluationsHint": "Guard evaluations will appear when transitions or ticks with guards execute",
  "debug.expression": "Expression",
  "debug.inputs": "Inputs",
  "debug.trait": "Trait",
  "debug.filterAll": "All",
  "debug.filterPassed": "Passed",
  "debug.filterFailed": "Failed",
  "debug.traitsInitHint": "Traits will appear when the state machine initializes",
  "debug.traitsMountHint": "Traits will appear when components using them are mounted",
  "debug.activeStates": "Active States",
  "debug.availableEvents": "Available Events",
  "debug.noTransitionsFromState": "No transitions from current state",
  "debug.guarded": "guarded",
  "debug.otherEvents": "Other Events (not available from current state)",
  "debug.recentTransitions": "Recent Transitions",
  "debug.transitionsCount": "{{count}} transitions",
  "debug.states": "States",
  "debug.transitions": "Transitions",
  "debug.guards": "Guards",
  "debug.debugModeHint": "Debug mode may not be enabled",
  "debug.entitiesSpawnHint": "Entities will appear when spawned",
  "debug.singleton": "Singleton",
  "debug.singletonsCount": "Singletons ({{count}})",
  "debug.runtimeCount": "Runtime ({{count}})",
  "debug.moreEntities": "+{{count}} more entities",
  "debug.persistent": "Persistent",
  "debug.loadedCount": "{{count}} loaded",
  "debug.notLoaded": "not loaded",
  "debug.eventsExecuteHint": "Events will appear as traits, ticks, and other systems execute",
  "debug.allCount": "All ({{count}})",
  "debug.autoScroll": "Auto-scroll",
  "debug.transitionsProcessHint": "Transitions will appear as the state machine processes events",
  "debug.transitionsRecorded": "{{count}} transitions recorded",
  "debug.guardLabel": "guard:",
  "debug.effectsCount": "{{count}} effects",
  "debug.bridgeInitHint": "The ServerBridge has not been initialized. Bridge health will appear once the runtime connects to the server.",
  "debug.never": "Never",
  "debug.connected": "Connected",
  "debug.disconnected": "Disconnected",
  "debug.lastError": "Last Error",
  "debug.totalEventsProcessed": "{{count}} total events processed",
  "debug.server": "server",
  "debug.clientEffectsCount": "{{count}} clientEffects",
  "debug.emitLabel": "emit:",
  "debug.rowsCount": "{{count}} rows",
  "debug.serverResponse": "server response",
  "debug.collapseVerificationTimeline": "Collapse verification timeline",
  "debug.expandVerificationTimeline": "Expand verification timeline",
  "debug.failCount": "{{count}} fail",
  "debug.ok": "OK",
  "debug.localCount": "{{count}} local",
  "debug.serverCount": "{{count}} server",
  "debug.waitingForTransitions": "Waiting for transitions...",
  "debug.tabDispatch": "Dispatch",
  "debug.tabVerify": "Verify",
  "debug.tabVerifyAlert": "Verify (!)",
  "debug.tabTimeline": "Timeline",
  "debug.tabBridge": "Bridge",
  "debug.tabTraits": "Traits",
  "debug.tabTicks": "Ticks",
  "debug.tabEntities": "Entities",
  "debug.tabEvents": "Events",
  "debug.tabGuards": "Guards",
  "debug.debugger": "Debugger",
  "debug.failedCount": "{{count}} failed",
  "debug.traitsCount": "{{count}} traits",
  "debug.idle": "Idle",
  "debug.openDebugger": "Open Debugger (`)",
  "debug.kflowVerifier": "KFlow Verifier",
  "debug.allPassing": "All passing",
  "debug.runtime": "Runtime",
  "debug.close": "Close (`)",
  "debug.toggleHint": "Press ` to toggle | window.__orbitalVerification for automation",
  "replyTree.expandReplies": "Expand replies",
  "replyTree.collapseReplies": "Collapse replies",
  "replyTree.voteOnReplyBy": "Vote on reply by {{author}}",
  "replyTree.replyTo": "Reply to {{author}}",
  "replyTree.replyToPlaceholder": "Reply to {{author}}\u2026",
  "replyTree.reply": "Reply",
  "replyTree.flagReplyBy": "Flag reply by {{author}}",
  "replyTree.flag": "Flag",
  "replyTree.send": "Send",
  "replyTree.continueThread": "Continue thread",
  "replyTree.noRepliesYet": "No replies yet.",
  "signaturePad.label": "Signature",
  "signaturePad.helperText": "Draw your signature above",
  "signaturePad.clear": "Clear",
  "signaturePad.confirm": "Confirm",
  "qrScanner.cameraUnavailable": "Camera unavailable",
  "qrScanner.paused": "Paused",
  "qrScanner.resumeScanning": "Resume scanning",
  "qrScanner.pauseScanning": "Pause scanning",
  "qrScanner.switchToFrontCamera": "Switch to front camera",
  "qrScanner.switchToRearCamera": "Switch to rear camera",
  "docSearch.placeholder": "Search documentation...",
  "stateMachine.loading": "Loading state machine\u2026",
  "stateMachine.noStateMachine": "No state machine to visualize",
  "avl.trigger": "Trigger",
  "avl.guard": "Guard",
  "avl.effects": "Effects",
  "avl.props": "Props",
  "avl.entity": "Entity",
  "avl.traits": "Traits",
  "avl.transition": "Transition",
  "avl.onEntity": "on {{entity}}",
  "avl.linkedTo": "linked to {{entity}}",
  "avl.pressEscToZoomOut": "Press Esc to zoom out",
  "avl.zoomIn": "Zoom in",
  "avl.zoomOut": "Zoom out",
  "avl.orbitalLabel": "Orbital: {{name}}",
  "avl.orbitalLabelHighlighted": "Orbital: {{name}} (highlighted)",
  "avl.noTraitData": "No trait data",
  "avl.computingLayout": "Computing layout...",
  "avl.noStateMachine": "No state machine",
  "avl.listensFor": "listens for {{event}}",
  "avl.emits": "emits {{event}}",
  "avl.pageLayout": "Page Layout",
  "avl.overlaySuffix": "(overlay)",
  "avl.stateCount": "states: {{count}}",
  "avl.transitionCount": "transitions: {{count}}",
  "avl.listensRail": "listens",
  "avl.emitsRail": "emits",
  "avl.now": "now",
  "avl.circuit.zone.entity": "entity",
  "avl.circuit.zone.store": "store",
  "avl.circuit.zone.bus": "bus",
  "avl.circuit.zone.screen": "screen",
  "avl.circuit.zone.route": "route",
  "avl.circuit.zone.toast": "toast",
  "avl.circuit.zone.remote": "remote",
  "avl.circuit.zone.instances": "instances",
  "avl.circuit.zone.flow": "flow",
  "avl.circuit.zone.timer": "timer",
  "avl.circuit.zone.model": "model",
  "avl.circuit.zone.system": "system",
  "avl.circuit.evaluating": "evaluating {{code}}",
  "avl.circuit.returned": "{{code}} \u2192 {{value}}",
  "avl.circuit.failed": "{{code}} failed: {{error}}",
  "avl.circuit.skipped": "{{code}} never ran",
  "avl.circuit.nextItem": "next item through {{code}}",
  "avl.circuit.step": "Step {{n}} / {{total}}",
  "avl.circuit.stack": "stack",
  "avl.glyph.application": "Application",
  "avl.glyph.orbital": "Orbital",
  "avl.glyph.entity": "Entity",
  "avl.glyph.trait": "Trait",
  "avl.glyph.page": "Page",
  "avl.glyph.state": "State",
  "avl.glyph.transition": "Transition",
  "avl.glyph.event": "Event",
  "avl.glyph.guard": "Guard",
  "avl.glyph.effect": "Effect",
  "avl.glyph.field": "Field",
  "avl.glyph.fieldType": "Field type",
  "avl.glyph.binding": "Binding",
  "avl.glyph.bindingRef": "Binding reference",
  "avl.glyph.persistence": "Persistence",
  "avl.glyph.operator": "Operator",
  "avl.glyph.sexpr": "Expression",
  "avl.glyph.literal": "Literal",
  "orbPreview.previewBadge": "Preview",
  "orbPreview.doubleClickToOpen": "Double-click to open",
  "orbPreview.dropToAddAndOpen": "Drop to add and open",
  "orbPreview.hasProblems": "This orbital has problems \u2014 open the warning at the top right to fix them",
  "orbPreview.dispatching": "Coordinator is dispatching to this orbital",
  "orbPreview.noPreview": "No preview available",
  "detailView.noTransitionData": "No transition data",
  "orbInspector.required": "req",
  "orbInspector.addField": "Add Field",
  "orbInspector.serviceMode": "Service Mode",
  "orbInspector.standalone": "Standalone",
  "orbInspector.embedded": "Embedded",
  "orbInspector.rendersOwnUi": "Renders its own UI",
  "orbInspector.headless": "Headless, wired to other behaviors",
  "orbInspector.addEffect": "Add Effect",
  "orbInspector.guardExpression": "Guard expression",
  "orbInspector.selectPatternForStyles": "Select a pattern to view its style tokens.",
  "orbInspector.tokens": "Tokens",
  "orbInspector.noTokenContract": "No token contract declared for this pattern.",
  "orbInspector.variant": "Variant",
  "orbInspector.size": "Size",
  "orbInspector.statesCount": "{{count}} states",
  "orbInspector.onEntity": " on {{entity}}",
  "orbInspector.projectThemeTokens": "Project theme tokens",
  "orbInspector.tokenGroup.colors": "Colors",
  "orbInspector.tokenGroup.radii": "Radii",
  "orbInspector.tokenGroup.spacing": "Spacing",
  "orbInspector.tokenGroup.shadows": "Shadows",
  "orbInspector.tab.inspector": "Inspector",
  "orbInspector.tab.styles": "Styles",
  "orbInspector.tab.design": "Design",
  "orbInspector.tab.prototype": "Prototype",
  "orbInspector.tab.code": "Code",
  "canvas.overview": "Overview",
  "canvas.modulesCount": "{{count}} modules",
  "canvas.switchToView": "Switch to {{label}} view",
  "lawReference.viewFullText": "View full law text",
  "statCard.defaultLabel": "Stat",
  "statCard.vsLastPeriod": "vs last period",
  "mediaGallery.upload": "Upload",
  "mediaGallery.noMediaDescription": "No media items to display.",
  "pagination.jumpPlaceholder": "Page",
  "table.selectRow": "Select row {{id}}",
  "card.selectItem": "Select {{item}}",
  "card.itemFallback": "item",
  "fileTree.noFiles": "No files",
  "masterDetail.selectItem": "Select an item to view details",
  "empty.createFirst": "Create your first item to get started.",
  "upload.dropOrBrowse": "Drop files here or click to browse",
  "upload.dropFilesHere": "Drop files here",
  "upload.accepted": "Accepted: {{accept}}",
  "upload.maxSize": "Max size: {{size}}",
  "upload.maxFiles": "Up to {{count}} files",
  "upload.error.maxFiles": "Maximum {{count}} files allowed",
  "upload.error.invalidType": "Invalid file type: {{name}}",
  "upload.error.tooLarge": "File too large: {{name}} (max {{size}})",
  "optionConstraint.requiredOne": "Required, pick 1",
  "optionConstraint.optionalOne": "Optional, pick up to 1",
  "optionConstraint.pickExactly": "Pick exactly {{count}}",
  "optionConstraint.pickRange": "Pick {{min}}-{{max}}",
  "optionConstraint.pickAtLeast": "Pick at least {{count}}",
  "optionConstraint.pickUpTo": "Pick up to {{count}}",
  "optionConstraint.optional": "Optional",
  "optionConstraint.outOfStock": "Out of stock",
  "optionConstraint.error.pickOne": "Pick 1 option",
  "optionConstraint.error.pickOnlyOne": "Pick only 1 option",
  "optionConstraint.error.pickMore": "Pick at least {{count}} more",
  "optionConstraint.error.removeOptions": "Remove {{count}} options",
  "stateMachine.pinned": "Pinned",
  "stateMachine.eventCount": "{{count}} events",
  "stateMachine.externalEffects": "External Effects",
  "stateMachine.legend.initial": "Initial",
  "stateMachine.legend.final": "Final",
  "stateMachine.legend.state": "State",
  "stateMachine.legend.multiEvent": "Multi-event",
  "relationSelect.selectPlaceholder": "Select...",
  "battle.cancel": "Cancel",
  "battle.defeat": "Defeat",
  "battle.endTurn": "End Turn",
  "battle.playAgain": "Play Again",
  "battle.turnsPlayed": "Turns Played",
  "battle.victory": "Victory",
  "builder.allPlaced": "All placed",
  "builder.blueprint": "Blueprint",
  "builder.build": "Build",
  "builder.components": "Components",
  "builder.empty": "Empty",
  "builder.reset": "Reset",
  "builder.success": "Success",
  "classifier.allCorrect": "All correct!",
  "classifier.check": "Check",
  "classifier.correct": "correct",
  "classifier.itemsToSort": "Items to sort",
  "classifier.reset": "Reset",
  "common.error": "Error",
  "debugger.allFound": "All bugs found!",
  "debugger.bugsFound": "bugs found",
  "debugger.findBugs": "Find {{count}} bugs",
  "debugger.reset": "Reset",
  "debugger.submit": "Submit",
  "error.genericLoad": "Failed to load",
  "error.loadingData": "Loading data",
  "eventHandler.addRule": "Add Rule",
  "eventHandler.chainComplete": "Chain complete!",
  "eventHandler.clickObject": "Click objects",
  "eventHandler.eventLog": "Event Log",
  "eventHandler.heardEvent": "{{object}} heard {{event}} \u2192 {{action}}",
  "eventHandler.noEvents": "No events yet",
  "eventHandler.noListeners": "No listeners for {{event}}",
  "eventHandler.rules": "{{count}}/{{max}} rules",
  "eventHandler.simulationStarted": "Simulating: {{events}}",
  "eventHandler.state": "State",
  "eventHandler.then": "then",
  "eventHandler.when": "When",
  "game.goal": "Goal",
  "game.hint": "Hint",
  "game.play": "Play",
  "game.reset": "Reset",
  "game.runTests": "Run Tests",
  "negotiator.chooseAction": "Choose an action",
  "negotiator.failed": "Negotiation failed",
  "negotiator.finalScore": "Final score",
  "negotiator.history": "History",
  "negotiator.opponent": "Opponent",
  "negotiator.playAgain": "Play Again",
  "negotiator.round": "Round {{current}} of {{total}}",
  "negotiator.success": "Negotiation successful",
  "negotiator.target": "Target",
  "negotiator.you": "You",
  "platformer.level": "Level",
  "platformer.lost": "Game Over",
  "platformer.nextLevel": "Next Level",
  "platformer.noLives": "No lives left",
  "platformer.playAgain": "Play Again",
  "platformer.score": "Score",
  "platformer.won": "You won!",
  "puzzle.tryAgainButton": "Try Again",
  "roguelike.atk": "ATK",
  "roguelike.cleared": "Dungeon cleared! Depth reached: {{depth}}",
  "roguelike.defeat": "Defeated!",
  "roguelike.depth": "Depth",
  "roguelike.enemy": "Enemy",
  "roguelike.hp": "HP",
  "roguelike.phase": "Phase",
  "roguelike.playAgain": "Play Again",
  "roguelike.player": "Hero",
  "roguelike.victory": "Victory!",
  "sequencer.actions": "Actions",
  "sequencer.dragActions": "Drag actions here",
  "sequencer.levelComplete": "Level complete!",
  "sequencer.yourSequence": "Your sequence",
  "simulator.correct": "Correct",
  "simulator.incorrect": "Incorrect",
  "simulator.parameters": "Parameters",
  "simulator.reset": "Reset",
  "simulator.simulate": "Simulate",
  "simulator.target": "Target",
  "stateArchitect.addTransition": "Add transition from {{state}}",
  "stateArchitect.addTransitionPrompt": "Click target state",
  "stateArchitect.allPassed": "All tests passed!",
  "stateArchitect.clickTarget": "Click a target state (current: {{state}})",
  "stateArchitect.gotState": "Got state: {{state}}",
  "stateArchitect.graph": "Graph",
  "stateArchitect.hideJson": "Hide JSON",
  "stateArchitect.showJson": "Show JSON",
  "stateArchitect.testResults": "Test Results",
  "stateArchitect.transitions": "{{count}} transitions",
  "stateArchitect.variables": "Variables: {{name}}",
  "stateArchitect.viewCode": "View Code",
  "td.defeat": "Defeat",
  "td.gold": "Gold",
  "td.lives": "Lives",
  "td.livesReachedZero": "Your base was overrun",
  "td.placeTower": "Place tower",
  "td.playAgain": "Play Again",
  "td.startWave": "Start Wave",
  "td.survivedAllWaves": "Survived all waves!",
  "td.victory": "Victory!",
  "td.wave": "Wave",
  "td.waveInProgress": "Wave in progress\u2026",
  "documentDetails.title": "Details",
  "documentPanel.untitled": "Untitled",
  "documentPanel.edit": "Edit",
  "documentPanel.done": "Done",
  "documentPanel.autosaveHint": "Saves as you type",
  "documentPanel.placeholder": "Start writing\u2026",
  "richTextEditor.editorToolbar": "Formatting toolbar",
  "richTextEditor.editorSurface": "Rich text editor",
  "richTextEditor.bold": "Bold",
  "richTextEditor.italic": "Italic",
  "richTextEditor.underline": "Underline",
  "richTextEditor.strikethrough": "Strikethrough",
  "richTextEditor.heading1": "Heading 1",
  "richTextEditor.heading2": "Heading 2",
  "richTextEditor.heading3": "Heading 3",
  "richTextEditor.bulletList": "Bullet list",
  "richTextEditor.numberedList": "Numbered list",
  "richTextEditor.quote": "Quote",
  "richTextEditor.code": "Code",
  "richTextEditor.link": "Add link",
  "richTextEditor.removeLink": "Remove link",
  "richTextEditor.divider": "Divider",
  "richTextEditor.linkPrompt": "Link address",
  "richTextEditor.image": "Insert image",
  "richTextEditor.imagePrompt": "Image URL",
  "richTextEditor.placeholder": "Start writing\u2026",
  "form.imageUrlFallback": "\u2026or paste an image address",
  "mermaid.unrenderable": "This diagram could not be displayed. Its source is shown below.",
  "orbPreview.play": "Play \u2014 interact with this screen",
  "orbPreview.pause": "Pause \u2014 select and edit",
  "inlineText.boundValue": "This text comes from data, so it can't be edited here.",
  "designOverlay.layoutVertical": "Vertical layout",
  "designOverlay.layoutHorizontal": "Horizontal layout",
  "designOverlay.spaceBetween": "Space between",
  "designOverlay.wrap": "Wrap",
  "designOverlay.align": "Align {{row}} {{column}}",
  "designOverlay.top": "top",
  "designOverlay.middle": "middle",
  "designOverlay.bottom": "bottom",
  "designOverlay.left": "left",
  "designOverlay.center": "center",
  "designOverlay.right": "right",
  "orbInspector.appearance": "Appearance",
  "orbInspector.editScope": "Edit scope",
  "orbInspector.scopeLocal": "This element",
  "orbInspector.scopeGlobal": "Theme",
  "orbInspector.fill": "Fill",
  "orbInspector.textColor": "Text",
  "orbInspector.borderColor": "Border",
  "orbInspector.radius": "Radius",
  "orbInspector.width": "Width",
  "orbInspector.height": "Height",
  "orbInspector.minWidth": "Min W",
  "orbInspector.maxWidth": "Max W",
  "orbInspector.minHeight": "Min H",
  "orbInspector.maxHeight": "Max H",
  "orbInspector.limitNone": "None",
  "orbInspector.absolute": "Absolute position",
  "orbInspector.constraintHorizontal": "Horizontal",
  "orbInspector.constraintVertical": "Vertical",
  "orbInspector.pinLeft": "Left",
  "orbInspector.pinRight": "Right",
  "orbInspector.pinLeftRight": "Left & right",
  "orbInspector.pinTop": "Top",
  "orbInspector.pinBottom": "Bottom",
  "orbInspector.pinTopBottom": "Top & bottom",
  "orbInspector.pinCenter": "Center",
  "orbInspector.pinScale": "Scale",
  "orbInspector.auto": "Auto",
  "orbInspector.notThemeBacked": "Not a theme value \u2014 set it on this element instead",
  "orbInspector.globalAffects": "Changes {{token}} everywhere it is used",
  "orbInspector.classNameIsBinding": "This element's classes come from a binding, so they can't be edited here",
  "orbInspector.sizingHug": "Hug contents",
  "orbInspector.sizingFill": "Fill container",
  "orbInspector.gap": "Gap",
  "orbInspector.padding": "Padding",
  "orbInspector.mixed": "Mixed",
  "orbInspector.custom": "Custom",
  "orbInspector.customRefused": "One custom value, like w-[243px] or bg-[#e14b2a].",
  "inlineText.fixedValue": "{{behavior}} sets this text \u2014 change it in its settings.",
  "inlineText.loading": "Still checking what this element lets you change.",
  "orbPreview.partOf": "Part of {{behavior}}",
  "avl.propBound": "From data: {{binding}}",
  "avl.propFixed": "Set by {{behavior}}",
  "avl.propChecking": "Checking\u2026",
  "avl.moreProps": "More ({{count}})",
  "knobField.addAValue": "Add a value\u2026",
  "knobField.addField": "Add field",
  "knobField.addItem": "Add {{label}}",
  "knobField.addOwnField": "Add your own field",
  "knobField.entityFields": "Entity fields",
  "knobField.fieldNamePlaceholder": "Field name",
  "knobField.items": "Items",
  "knobField.missingItemSchema": "Missing item schema \u2014 cannot render structured list editor.",
  "knobField.missingObjectSchema": "Missing object schema \u2014 cannot render structured form.",
  "knobField.number": "Number",
  "knobField.other": "Other...",
  "knobField.removeItem": "Remove",
  "knobField.specifyPlaceholder": "Specify...",
  "knobField.yourAnswer": "Your answer\u2026",
  "avl.settings": "Settings",
  "avl.settingsOf": "{{behavior}} settings",
  "canvas.liveState": "Live",
  "canvas.verifyTransition": "Verify this transition",
  "canvas.verifyTrait": "Verify this trait (play its walk)",
  "canvas.verifyPause": "Pause verification",
  "canvas.verifyStop": "Stop verification",
  "canvas.verdict.pass": "Verified",
  "canvas.verdict.fail": "Failed",
  "canvas.verdict.stale": "Changed since verified",
  "canvas.verdict.running": "Verifying",
  "canvas.stateOf": "State shown on {{orbital}}",
  "canvas.previousOrbital": "Previous orbital (Shift+Tab)",
  "canvas.nextOrbital": "Next orbital (Tab)",
  "canvas.focusedOrbital": "Focused orbital",
  "canvas.scopeLocal": "Focus",
  "canvas.scopeWorld": "All",
  "canvas.scopeLocalHint": "Show only the focused orbital",
  "canvas.scopeWorldHint": "Show every orbital",
  "canvas.screenSize": "Screen size",
  "dockLayout.collapse.sidebar": "Collapse side panel",
  "dockLayout.expand.sidebar": "Expand side panel",
  "dockLayout.collapse.secondary-sidebar": "Collapse right panel",
  "dockLayout.expand.secondary-sidebar": "Expand right panel",
  "dockLayout.collapse.bottom-panel": "Collapse bottom panel",
  "dockLayout.expand.bottom-panel": "Expand bottom panel",
  "dockLayout.openMenu": "Menu",
  "dockLayout.menu": "Menu",
  "dockLayout.backToMenu": "Back to the menu",
  "commitRow.kind.user": "Your save",
  "commitRow.kind.agent": "Agent change",
  "commitRow.kind.restore": "Restore",
  "commitRow.kind.undo": "Undo",
  "commitRow.current": "Current",
  "commitRow.restore": "Restore",
  "changeList.added": "Added",
  "changeList.modified": "Modified",
  "changeList.removed": "Removed",
  "changeList.before": "Before",
  "changeList.after": "After",
  "changeList.inspect": "Inspect",
  "changeList.empty": "No changes in this version.",
  "commitRow.kind.redo": "Redo",
  "commitRow.kind.snapshot": "Snapshot",
  "codeAssist.thinking": "Thinking\u2026",
  "codeAssist.findingFixes": "Finding fixes\u2026",
  "codeAssist.suggested": "{{count}} suggested",
  "codeAssist.keys": "Tab accept \xB7 \u2318/Ctrl+Enter accept all \xB7 Esc dismiss",
  "codeAssist.acceptAll": "Accept all",
  "codeAssist.suggestFixes": "Suggest fixes for {{count}} problem(s) \xB7 \u2318/Ctrl+.",
  "codeAssist.line": "Line {{line}}",
  "avl.play.step": "Step",
  "avl.play.play": "Play",
  "avl.play.pause": "Pause",
  "avl.play.stop": "Stop",
  "avl.play.payload": "Payload",
  "avl.play.fired": "Fired",
  "avl.play.blocked": "Blocked",
  "avl.play.notReached": "Not taken",
  "avl.play.guardPassed": "Guard passed",
  "avl.play.guardFailed": "Guard failed",
  "avl.play.notPlayed": "Not played yet. Step runs it on the mock row.",
  "avl.play.sceneStep": "Step {{n}} of {{total}}",
  "avl.play.scene": "Scene",
  "avl.play.effectFailed": "Failed",
  "avl.system.counts": "{{traits}} traits \xB7 {{pages}} pages \xB7 {{fields}} fields",
  "avl.system.exchanges": "Exchanges {{events}}",
  "avl.system.openTraits": "Open traits",
  "avl.system.openCode": "Open code",
  "avl.system.preview": "Preview",
  "avl.system.connected": "Connected \xB7 {{count}}",
  "avl.system.standalone": "Standalone \xB7 {{count}} \u2014 no events with other orbitals",
  "avl.system.summary": "{{orbitals}} orbitals \xB7 {{wires}} wires",
  "avl.system.search": "Find an orbital or event",
  "avl.system.wiresOnly": "Wires only",
  "avl.system.lensEvents": "Events",
  "avl.system.lensDependencies": "Dependencies",
  "avl.deps.hint": "Click an orbital or behavior to see what it is built from and what depends on it",
  "avl.deps.selected": "{{name}} \xB7 built from {{upstream}} \xB7 {{downstream}} depend on it",
  "avl.deps.legendUpstream": "Upstream (built from)",
  "avl.deps.legendDownstream": "Downstream (depends on it)",
  "avl.deps.column.app": "Your app \xB7 orbitals",
  "avl.deps.column.io": "io \xB7 realizations",
  "avl.deps.column.std": "std \xB7 behaviors",
  "avl.deps.column.primitive": "std \xB7 UI primitives",
  "avl.deps.column.unknown": "Outside the registries",
  "avl.deps.search": "Find an orbital or behavior",
  "avl.flow.lensFlow": "Flow",
  "avl.flow.lensTraits": "Traits",
  "avl.flow.selected": "{{name}} \xB7 {{into}} trigger it \xB7 it triggers {{out}}",
  "avl.flow.summary": "{{traits}} traits \u2192 {{own}} own + {{composed}} composed ({{pieces}} render pieces folded in) \xB7 click one to see what triggers it",
  "avl.flow.showTraits": "Show its traits",
  "avl.flow.legendInto": "Triggers it",
  "avl.flow.legendOut": "It triggers",
  "avl.flow.showing": "Showing {{name}} \xB7 {{count}} traits",
  "avl.flow.showAll": "Show all",
  "avl.deps.column.own": "Own traits",
  "avl.deps.column.client": "Clients",
  "avl.deps.column.host": "Host",
  "avl.deps.column.service": "Services",
  "avl.deps.column.store": "Data stores",
  "avl.deps.column.external": "External APIs",
  "avl.unit.status.ok": "Healthy",
  "avl.unit.status.degraded": "Degraded",
  "avl.unit.status.down": "Failing",
  "avl.unit.status.idle": "No traffic",
  "avl.flow.traitsCount": "{{count}} traits",
  "avl.flow.piecesCount": "{{count}} render pieces",
  "avl.flow.traitsCountOne": "1 trait",
  "avl.flow.piecesCountOne": "1 render piece",
  "gantt.datesReversed": "Ends before it starts \u2014 check its dates",
  "chatBar.askTheAgentAnything": "Ask the agent anything\u2026",
  "canvas.loadingMessage": "Loading\u2026",
  "chatBar.cancelGeneration": "Cancel generation",
  "chatBar.clearSelection": "Clear selection",
  "chatBar.editing": "Editing",
  "chatBar.pauseTheAgentYouCanEdit": "Pause the agent \u2014 you can edit the canvas while it waits",
  "chatBar.resume": "Resume",
  "chatBar.resumeTheAgentYourCanvasEdits": "Resume the agent \u2014 your canvas edits are kept",
  "chatBar.sendMessage": "Send message",
  "openFile.retry": "Retry",
  "subagentTrace.content": "Content",
  "subagentTrace.coordinator": "Coordinator",
  "subagentTrace.countDone": "{{count}} done",
  "subagentTrace.countRunning": "{{count}} running",
  "subagentTrace.densityCompact": "Compact",
  "subagentTrace.densityRich": "Detailed",
  "subagentTrace.eventsCount": "{{count}} events",
  "subagentTrace.messagesCount": "{{count}} messages",
  "subagentTrace.noAgentActivity": "No agent activity yet",
  "subagentTrace.noConversationLog": "No conversation log",
  "subagentTrace.noSubagentsActive": "No subagents active",
  "subagentTrace.noSubagentsForOrbital": "No subagents for {{orbital}}",
  "subagentTrace.organism": "Organism",
  "subagentTrace.pendingQuestion": "{{count}} pending question",
  "subagentTrace.pendingQuestions": "{{count}} pending questions",
  "subagentTrace.planOrbital": "Plan \xB7 {{count}} orbital",
  "subagentTrace.planOrbitals": "Plan \xB7 {{count}} orbitals",
  "subagentTrace.reasoning": "Reasoning",
  "subagentTrace.subagentCount": "{{count}} subagent",
  "subagentTrace.subagentCountPlural": "{{count}} subagents",
  "subagentTrace.subagents": "Subagents",
  "subagentTrace.subagentsWithCount": "Subagents ({{count}})",
  "subagentTrace.thinking": "thinking",
  "subagentTrace.toolCallCount": "{{count}} tool call",
  "subagentTrace.toolCallCountPlural": "{{count}} tool calls",
  "subagentTrace.toolCalls": "Tool calls",
  "subagentTrace.trace": "Trace",
  "subagentTrace.waitingForProcessData": "Waiting for process data\u2026",
  "subagentTrace.wasOrganism": "was {{organism}}",
  "common.moveUp": "Move up",
  "common.moveDown": "Move down",
  "repeatable.addedIn": "Added in:",
  "repeatable.minItemsOne": "At least 1 item required",
  "repeatable.minItems": "At least {{count}} items required",
  "lightbox.counter": "{{current}} / {{total}}",
  "aria.imageViewer": "Image viewer",
  "aria.ratingValue": "Rating: {{value}} out of {{max}}",
  "pagination.label": "Pagination",
  "pagination.pageOf": "{{page}} / {{total}}",
  "violationAlert.citation": "{{law}} Art. {{article}}",
  "aria.search": "Search",
  "form.fixFields": "Please fix {{count}} fields",
  "form.invalidValue": "Invalid value",
  "bloomQuiz.question": "Question {{number}}",
  "bloomQuiz.hideAnswer": "Hide Answer",
  "bloomQuiz.revealAnswer": "Reveal Answer",
  "bloomQuiz.answer": "Answer:",
  "bloomQuiz.level.remember": "Remember",
  "bloomQuiz.level.understand": "Understand",
  "bloomQuiz.level.apply": "Apply",
  "bloomQuiz.level.analyze": "Analyze",
  "bloomQuiz.level.evaluate": "Evaluate",
  "bloomQuiz.level.create": "Create",
  "reflection.title": "Pause & Reflect",
  "reflection.placeholder": "Your thoughts...",
  "reflection.saveContinue": "Save & Continue",
  "reflection.answeredEdit": "\u2713 Answered \xB7 Edit",
  "reflection.answerQuestion": "Answer this question",
  "activation.title": "Before You Begin...",
  "activation.placeholder": "Jot down your thoughts...",
  "activation.continue": "Continue to Lesson \u2192",
  "activation.skip": "Skip for now",
  "activation.answeredEdit": "\u2713 Answered \xB7 Edit response",
  "connection.title": "Building On What You Know",
  "likert.stronglyDisagree": "Strongly Disagree",
  "likert.disagree": "Disagree",
  "likert.neutral": "Neutral",
  "likert.agree": "Agree",
  "likert.stronglyAgree": "Strongly Agree",
  "likert.ariaLabel": "Likert scale",
  "dateRange.last7Days": "Last 7 days",
  "dateRange.last30Days": "Last 30 days",
  "dateRange.thisMonth": "This Month",
  "dateRange.thisQuarter": "This Quarter",
  "dateRange.yearToDate": "YTD",
  "dateRange.from": "From",
  "dateRange.to": "To",
  "jsonTree.type.text": "txt",
  "jsonTree.type.number": "num",
  "jsonTree.type.boolean": "y/n",
  "jsonTree.valueType": "Value type",
  "jsonTree.itemCountOne": "{{count}} item",
  "jsonTree.itemCountOther": "{{count}} items",
  "jsonTree.fieldCountOne": "{{count}} field",
  "jsonTree.fieldCountOther": "{{count}} fields",
  "jsonTree.collapse": "Collapse",
  "jsonTree.expand": "Expand",
  "jsonTree.addItem": "Add item",
  "jsonTree.addField": "Add field",
  "import.phase.fetching": "Fetching",
  "import.phase.mapping": "Mapping",
  "import.phase.reviewing": "Reviewing",
  "import.phase.committing": "Committing",
  "import.phase.done": "Done",
  "import.phase.failed": "Failed",
  "import.staged": "Staged {{count}}",
  "import.committed": "Committed {{count}}",
  "import.failedCount": "Failed {{count}}",
  "import.noUnitsStaged": "No units staged.",
  "import.skipped": "Skipped",
  "import.confirmImport": "Confirm import",
  "coachmark.skip": "Skip",
  "coachmark.gotIt": "Got it",
  "documentViewer.noDocumentDescription": "No document to display.",
  "documentViewer.iframeTitle": "Document",
  "emojiPicker.addEmoji": "Add emoji",
  "emojiPicker.search": "Search emoji\u2026",
  "iconPicker.category": "icons",
  "iconPicker.search": "Search icons\u2026",
  "commandPalette.placeholder": "Type a command...",
  "commandPalette.noMatches": "No matching commands",
  "gridPicker.all": "All",
  "gridPicker.moreRefine": "+{{count}} more \u2014 refine your search",
  "graphCanvas.noNodes": "No nodes to display.",
  "codeBlock.noCode": "No code to display.",
  "codeBlock.region": "Code",
  "fab.action": "Action",
  "fab.closeActions": "Close actions",
  "fab.openActions": "Open actions",
  "featureCard.learnMore": "Learn more",
  "fileTree.collapse": "Collapse",
  "fileTree.expand": "Expand",
  "fileTree.nodeAction": "Node action",
  "voteStack.ariaLabel": "Vote",
  "numberStepper.ariaLabel": "Number stepper",
  "carousel.goToSlide": "Go to slide {{number}}",
  "tagInput.placeholder": "Type and press Enter\u2026",
  "tagInput.removeTag": "Remove {{tag}}",
  "nodeSlot.none": "\u2014 none \u2014",
  "nodeSlot.props": "props",
  "positionedCanvas.status.empty": "Empty",
  "positionedCanvas.status.seated": "Seated",
  "positionedCanvas.status.ordered": "Ordered",
  "positionedCanvas.status.awaitingBill": "Awaiting bill",
  "positionedCanvas.status.cleaning": "Cleaning",
  "positionedCanvas.capacity": "Cap {{count}}",
  "propertyInspector.editInSource": "{{type}} \u2014 edit in source",
  "propertyInspector.config": "Config",
  "propertyInspector.noProperties": "No configurable properties.",
  "propertyInspector.tier.presentation": "presentation",
  "propertyInspector.tier.domain": "domain",
  "propertyInspector.tier.policy": "policy",
  "propertyInspector.tier.infra": "infra",
  "propertyInspector.tier.internal": "internal",
  "upload.error.readFailed": "Could not read the selected file",
  "selection.ask": "Ask",
  "selection.note": "Note",
  "selection.toolbar": "Selection actions",
  "qrScanner.apiUnavailable": "Camera API not available in this environment",
  "themeToggle.switchToLight": "Switch to light mode",
  "themeToggle.switchToDark": "Switch to dark mode",
  "themeToggle.light": "Light",
  "themeToggle.dark": "Dark",
  "avatar.alt": "Avatar",
  "avatar.status": "Status: {{status}}",
  "avatar.status.online": "online",
  "avatar.status.offline": "offline",
  "avatar.status.away": "away",
  "avatar.status.busy": "busy",
  "avatar.badge": "Badge: {{badge}}",
  "progressBar.ariaLabel": "Progress: {{percent}}",
  "rangeSlider.ariaLabel": "Range slider",
  "select.nSelected": "{{count}} selected",
  "select.searchPlaceholder": "Search\u2026",
  "statusDot.online": "online",
  "statusDot.offline": "offline",
  "statusDot.away": "away",
  "statusDot.busy": "busy",
  "statusDot.warning": "warning",
  "statusDot.critical": "critical",
  "trendIndicator.up": "up",
  "trendIndicator.down": "down",
  "trendIndicator.flat": "flat",
  "trendIndicator.withValue": "{{direction}} {{value}}",
  "chart.weekOf": "Week of {{date}}",
  "chart.quarterOf": "Q{{quarter}} {{year}}",
  "detailPanel.section.overview": "Overview",
  "detailPanel.section.metrics": "Metrics",
  "detailPanel.section.timeline": "Timeline",
  "detailPanel.section.details": "Details",
  "codeRunner.run": "Run",
  "codeRunner.output": "Output",
  "codeRunner.exit": "Exit {{code}}",
  "codeRunner.noOutput": "No output",
  "codeRunner.testPassed": "Test {{number}}: passed",
  "codeRunner.testFailed": "Test {{number}}: failed",
  "codeRunner.input": "Input: {{value}}",
  "codeRunner.expected": "Expected: {{value}}",
  "codeRunner.actual": "Actual: {{value}}",
  "toast.notification": "Notification",
  "subagentTrace.errorMessage": "Error: {{message}}",
  "subagentTrace.role.system": "system",
  "subagentTrace.role.user": "user",
  "subagentTrace.role.assistant": "assistant",
  "subagentTrace.role.tool": "tool",
  "subagentTrace.subagent": "subagent",
  "subagentTrace.activityType.tool_call": "tool call",
  "subagentTrace.activityType.tool_result": "tool result",
  "subagentTrace.activityType.message": "message",
  "subagentTrace.activityType.error": "error",
  "subagentTrace.activityType.file_operation": "file operation",
  "subagentTrace.activityType.schema_diff": "schema diff",
  "subagentTrace.fileOperation.ls": "list",
  "subagentTrace.fileOperation.read_file": "read",
  "subagentTrace.fileOperation.write_file": "write",
  "subagentTrace.fileOperation.edit_file": "edit",
  "subagentTrace.diffPreview": "diff {{path}}",
  "subagentTrace.success": "success",
  "subagentTrace.fail": "fail",
  "subagentTrace.badgeError": "error",
  "subagentTrace.badgeFile": "file",
  "subagentTrace.badgeDiff": "diff",
  "subagentTrace.unattached": "(unattached)",
  "dashboard.defaultAppName": "App",
  "dashboard.defaultUserName": "User",
  "auth.defaultAppName": "My App",
  "counter.title": "Counter",
  "counter.resetToZero": "Reset to 0",
  "subagentTrace.activityType.milestone": "milestone",
  "subagentTrace.activityType.analysis": "analysis",
  "subagentTrace.activityType.cancelled": "cancelled",
  "subagentTrace.activityType.clarification_question": "clarification question",
  "subagentTrace.activityType.coordinator_decision": "coordinator decision",
  "subagentTrace.activityType.done": "done",
  "subagentTrace.activityType.llm_response": "model response",
  "subagentTrace.activityType.orbital_done": "orbital done",
  "subagentTrace.activityType.orbital_started": "orbital started",
  "subagentTrace.activityType.pending_question": "pending question",
  "subagentTrace.activityType.plan_committed": "plan committed",
  "subagentTrace.activityType.schema_change": "schema change",
  "gameMenu.defaultTitle": "Epic Quest",
  "gameMenu.newGame": "New Game",
  "gameMenu.continue": "Continue",
  "gameMenu.settings": "Settings",
  "choiceButton.defaultText": "Charge forward into the fray",
  "dialogueBubble.defaultSpeaker": "Hero",
  "dialogueBubble.defaultText": "The dungeon awaits. Choose your path wisely.",
  "gameShell.defaultName": "Game",
  "gameHud.health": "Health",
  "gameHud.score": "Score",
  "gameHud.lives": "Lives",
  "gameHud.time": "Time",
  "gameHud.hp": "HP",
  "gameHud.mp": "MP",
  "gameHud.level": "Level",
  "controlGrid.jump": "Jump",
  "controlGrid.attack": "Attack",
  "controlGrid.dodge": "Dodge",
  "gameAudio.muted": "Muted",
  "gameAudio.soundOn": "Sound on",
  "timerDisplay.seconds": "{{count}}s",
  "learningCanvas.loading": "Loading canvas\u2026",
  "physicsPreset.projectileMotion": "Projectile Motion",
  "physicsPreset.simplePendulum": "Simple Pendulum",
  "physicsPreset.springOscillator": "Spring Oscillator",
  "physicsPreset.projectileMotionDescription": "Launch a ball and observe parabolic trajectory under gravity.",
  "physicsPreset.simplePendulumDescription": "A mass on a string swinging under gravity.",
  "physicsPreset.springOscillatorDescription": "A mass bouncing on a spring \u2014 simple harmonic motion.",
  "physicsPreset.launchAngle": "Launch angle (deg)",
  "physicsPreset.initialVelocity": "Initial velocity (m/s)",
  "physicsPreset.gravity": "Gravity (m/s\xB2)",
  "physicsPreset.stringLength": "String length (px)",
  "physicsPreset.mass": "Mass (kg)",
  "physicsPreset.springStiffness": "Spring stiffness (k)",
  "physicsPreset.damping": "Damping",
  "editor.tile": "Tile: {{position}}",
  "editor.grid": "Grid: {{width}}x{{height}}",
  "editor.units": "Units: {{count}}",
  "editor.features": "Features: {{count}}",
  "editor.modeSelect": "Select",
  "editor.modePaint": "Paint",
  "editor.modeUnit": "Unit",
  "editor.modeFeature": "Feature",
  "editor.modeErase": "Erase",
  "canvas3d.errorTitle": "3D Scene Error",
  "canvas3d.errorMessage": "Something went wrong while rendering the 3D scene.",
  "canvas3d.errorDetails": "Error Details",
  "canvas3d.reloadPage": "Reload Page",
  "canvas3d.loadingScene": "Loading 3D Scene...",
  "canvas3d.errorWithMessage": "Error: {{message}}",
  "orbPreview.serverUnreachable": "Preview server unreachable \u2014 running locally. Server-side state and persistence are disabled.",
  "verification.unknownError": "Unknown error",
  "debug.ticksHint": "Ticks will appear when trait tick handlers are running",
  "debug.justNow": "just now",
  "debug.secondsAgo": "{{count}}s ago",
  "debug.minutesAgo": "{{count}}m ago",
  "debug.tickInterval": "{{count}}ms",
  "debug.tickRunOne": "{{count}} run",
  "debug.tickRunOther": "{{count}} runs",
  "debug.tickExec": "{{count}}ms exec",
  "debug.activeCount": "Active ({{count}})",
  "debug.inactiveCount": "Inactive ({{count}})",
  "debug.verificationHint": "Checks will appear as the app executes transitions and effects",
  "debug.passedCount": "{{count}} passed",
  "debug.warningsCount": "{{count}} warnings",
  "debug.pendingCount": "{{count}} pending",
  "debug.totalChecksCount": "{{count}} total checks",
  "walkMinimap.engineProgress": "Engine: {{done}}/{{total}}",
  "walkMinimap.domCount": "DOM: {{count}}",
  "walkMinimap.engine": "Engine",
  "walkMinimap.dom": "DOM",
  "avlLegend.eventFlow": "Event flow",
  "avlLegend.orbitalBoundary": "Orbital boundary",
  "avlLegend.entityNucleus": "Entity (nucleus)",
  "avlLegend.traitRing": "Trait ring",
  "avlLegend.externalLink": "External link",
  "avlLegend.initialState": "Initial state",
  "avlLegend.eventEffects": "Event + effects",
  "avlLegend.emitExternal": "Emit (external)",
  "avlLegend.slotTarget": "Slot target",
  "avlLegend.bindingPath": "Binding (@path)",
  "zoomLegend.legend": "Legend",
  "zoomLegend.hide": "Hide",
  "zoomLegend.fieldTypes": "Field types",
  "zoomLegend.stateChain": "State chain",
  "zoomLegend.eventWire": "Event wire",
  "zoomLegend.stateMachine": "State machine",
  "zoomLegend.emitListen": "Emit/Listen",
  "zoomLegend.terminalState": "Terminal state",
  "zoomLegend.hubState": "Hub state",
  "zoomLegend.triggerEvent": "Trigger event",
  "zoomLegend.guardDiamond": "Guard diamond",
  "zoomBreadcrumb.system": "System",
  "zoomBreadcrumb.module": "Module",
  "zoomBreadcrumb.behavior": "Behavior",
  "zoomBreadcrumb.detail": "Detail",
  "avlSwimLane.listens": "Listens",
  "avlSwimLane.emits": "Emits",
  "avlTransitionScene.slots": "Slots",
  "avl3d.type": "Type",
  "avl3d.typeInitial": "Initial",
  "avl3d.typeTerminal": "Terminal",
  "avl3d.typeStandard": "Standard",
  "avl3d.incoming": "Incoming",
  "avl3d.outgoing": "Outgoing",
  "avl3d.status": "Status",
  "avl3d.pages": "Pages",
  "avl3d.fieldCountOne": "{{count}} field",
  "avl3d.fieldCountOther": "{{count}} fields",
  "avl3d.states": "States",
  "avl3d.events": "Events",
  "avl3d.transitions": "Transitions",
  "avl3d.effectCountOne": "{{count}} effect",
  "avl3d.effectCountOther": "{{count}} effects",
  "avlBehaviorGlyph.ariaLabel": "{{name}} behavior glyph",
  "orbPreview.layer.infrastructure": "Infrastructure",
  "orbPreview.layer.services": "Services",
  "orbPreview.layer.uiPatterns": "UI Patterns",
  "orbPreview.layer.game": "Game",
  "orbPreview.layer.ml": "ML",
  "orbPreview.layer.domain": "Domain",
  "orbPreview.layer.community": "Community",
  "screenSize.mobile": "Mobile",
  "screenSize.tablet": "Tablet",
  "screenSize.laptop": "Laptop",
  "screenSize.wide": "Wide",
  "flowCanvas.presetSize": "{{label}} ({{width}}px)",
  "avl.breadcrumb.transitionNumber": "Transition #{{n}}",
  "orbInspector.pattern": "Pattern",
  "orbInspector.slotLabel": "slot: {{slot}}",
  "detailPanel.section.activity": "Activity",
  "detailPanel.section.lineItems": "Line items",
  "detailPanel.tab.overview": "Overview",
  "detailPanel.thread.empty": "No messages yet",
  "detailPanel.openImage": "Open image",
  "detailPanel.showImage": "Show image {{index}}",
  "aria.clearSelection": "Clear selection",
  "aria.searchOptions": "Search options",
  "aria.zoomIn": "Zoom in",
  "aria.zoomOut": "Zoom out",
  "aria.previousPage": "Previous page",
  "aria.nextPage": "Next page",
  "aria.downloadDocument": "Download document",
  "aria.printDocument": "Print document",
  "aria.wrapLines": "Wrap lines",
  "aria.copyCode": "Copy code",
  "aria.clearInput": "Clear input",
  "aria.skipToContent": "Skip to content",
  "aria.mainNavigation": "Main navigation",
  "aria.carouselSlides": "Slides",
  "aria.minimap": "Minimap",
  "aria.canvasScene": "Game scene",
  "aria.learningCanvas": "Interactive diagram",
  "aria.scene3d": "3D scene",
  "aria.graphCanvas": "Graph",
  "aria.positionedCanvas": "Floor plan",
  "aria.walkTraitDone": "completed",
  "aria.walkTraitPending": "pending",
  "aria.walkGraph": "State graph for {{trait}}: {{from}} to {{to}}",
  "aria.loading": "Loading",
  "agentActivity.toolCall": "Called {{tool}}",
  "agentActivity.toolResult": "{{tool}} returned",
  "agentActivity.toolRows": "{{count}} rows",
  "agentActivity.thinking": "Thinking\u2026",
  "agentActivity.analyzed": "Analyzed your request \u2014 {{organism}}",
  "agentActivity.renamed": "Rename {{from}} \u2192 {{to}}",
  "agentActivity.deleted": "Remove {{orbitalName}}",
  "agentActivity.roster": "Planning {{count}} orbitals",
  "agentActivity.orbitalStarted": "Working on {{orbitalName}}\u2026",
  "agentActivity.orbitalStartedSettled": "Started {{orbitalName}}",
  "agentActivity.orbitalDone": "{{orbitalName}} ready",
  "agentActivity.orbitalCounts": "{{traitCount}} traits, {{transitionCount}} transitions",
  "agentActivity.change.orbital-added": "Added {{orbitalName}}",
  "agentActivity.change.orbital-removed": "Removed {{orbitalName}}",
  "agentActivity.change.entity-fields-changed": "Changed the data fields of {{orbitalName}}",
  "agentActivity.change.trait-added": "Added a behavior to {{orbitalName}}",
  "agentActivity.change.trait-removed": "Removed a behavior from {{orbitalName}}",
  "agentActivity.change.state-machine-changed": "Changed the flow of {{orbitalName}}",
  "agentActivity.change.guard-changed": "Changed a rule in {{orbitalName}}",
  "agentActivity.change.effect-changed": "Changed what {{orbitalName}} does",
  "agentActivity.change.render-ui-changed": "Changed the design of {{orbitalName}}",
  "agentActivity.change.event-wiring-changed": "Changed the connections of {{orbitalName}}",
  "agentActivity.change.page-changed": "Changed the pages of {{orbitalName}}",
  "agentActivity.change.behavior-composed": "Composed a behavior into {{orbitalName}}",
  "agentActivity.done": "Done \u2014 {{count}} orbitals ready",
  "agentActivity.cancelled": "Cancelled",
  "agentActivity.jump": "Show",
  "agentActivity.emptyTitle": "No activity yet",
  "agentActivity.emptyDescription": "Send a message and the agent's work shows up here.",
  "agentActivity.fileOperation": "{{operation}}",
  "agentActivity.schemaDiff": "Edited {{filePath}}",
  "agentActivity.coordinatorDecision": "Chose {{organism}}",
  "agentActivity.change.trait-config-changed": "Changed the settings of {{orbitalName}}",
  "agentActivity.change.theme-changed": "Changed the theme of {{orbitalName}}",
  "agentActivity.llmResponse": "Raw LLM response",
  "agentActivity.llmDuration": "{{seconds}}s",
  "agentActivity.llmTokens": "{{prompt}} in / {{completion}} out tokens",
  "agentActivity.llmResponseLabel": "Response",
  "agentActivity.llmSystemPrompt": "System prompt",
  "agentActivity.llmUserPrompt": "User prompt",
  "agentActivity.llmToolCalls": "Tool calls",
  "agentActivity.showRawLlm": "Raw LLM",
  "agentActivity.earlierConversations": "Earlier conversations ({{count}})",
  "agentActivity.earlierActivity": "Earlier activity",
  "tabs.scrollStart": "Scroll tabs back",
  "tabs.scrollEnd": "Scroll tabs forward",
  "agentChat.workedThrough": "Worked through {{count}} steps",
  "agentChat.newMessages": "New messages",
  "agentChat.copy": "Copy reply",
  "agentChat.copied": "Copied",
  "agentChat.today": "Today",
  "agentChat.yesterday": "Yesterday",
  "agentChat.emptyDescription": "Ask in your own words \u2014 the assistant can look things up and make changes for you.",
  "avl.effectCategory.ui": "Screen \u2014 changes what the user sees",
  "avl.effectCategory.data": "Data \u2014 reads, changes or saves records",
  "avl.effectCategory.communication": "Messages \u2014 sends an event, a notification or a request",
  "avl.effectCategory.lifecycle": "Lifecycle \u2014 starts or removes running instances",
  "avl.effectCategory.control": "Flow \u2014 decides what runs next",
  "avl.effectCategory.async": "Timing \u2014 waits, delays or runs things together",
  "avl.effectCategory.compute": "Compute \u2014 runs a model or a calculation",
  "avl.effectCategory.system": "System \u2014 works with the platform and its tools",
  "avl.stateInitial": "start",
  "avl.stateTerminal": "end",
  "avl.guardCaption": "The transition only fires when this check is true.",
  "avl.effectsCaption": "What runs, in order, when the transition fires."
};

export { en_default };
